import { DeckDTO, UserDTO } from '@/generated';
import { Role } from '@/models/user';

export const isDeckEditor = (deck?: DeckDTO, user?: UserDTO) =>
  !deck ? false : deck?.creatorId === user?.userId || user?.roles.includes(Role.Admin) || deck?.editorIds?.includes(user?.userId ?? '');

export const isDeckOwner = (deck: DeckDTO, userId?: string) => (deck.creatorId === userId && deck.ownerId === undefined) || deck.ownerId === userId;
